import React, { useEffect, useState, useRef } from 'react';
import { SearchIcon, FilterIcon, BookOpenIcon, ShieldIcon, UsersIcon, BriefcaseIcon, CheckCircleIcon, ClockIcon, StarIcon, ChevronDownIcon, ChevronRightIcon, BadgeCheckIcon, ArrowRightIcon, ArrowLeftIcon, GraduationCapIcon, LightbulbIcon } from 'lucide-react';
import { Header } from './Header';
import { Footer } from './Footer';
export const AllCoursesPage = () => {
  return <div className="flex flex-col min-h-screen w-full bg-white text-charcoal" data-id="element-44">
      <style jsx global data-id="element-45">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        html {
          scroll-behavior: smooth;
        }
        body {
          font-family: 'Inter', sans-serif;
        }
        .gradient-text {
          background: linear-gradient(135deg, #0b757a 0%, #1ddbdb 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .card-hover {
          transition: all 0.3s ease;
        }
        .card-hover:hover {
          transform: translateY(-8px);
        }
        .grid-animate > * {
          opacity: 0;
          transform: translateY(20px);
          transition:
            opacity 0.5s ease,
            transform 0.5s ease;
        }
        .grid-animate.visible > * {
          opacity: 1;
          transform: translateY(0);
        }
        .grid-animate.visible > *:nth-child(1) {
          transition-delay: 0.1s;
        }
        .grid-animate.visible > *:nth-child(2) {
          transition-delay: 0.15s;
        }
        .grid-animate.visible > *:nth-child(3) {
          transition-delay: 0.2s;
        }
        .grid-animate.visible > *:nth-child(4) {
          transition-delay: 0.25s;
        }
        .grid-animate.visible > *:nth-child(5) {
          transition-delay: 0.3s;
        }
        .grid-animate.visible > *:nth-child(6) {
          transition-delay: 0.35s;
        }
        .grid-animate.visible > *:nth-child(7) {
          transition-delay: 0.4s;
        }
        .grid-animate.visible > *:nth-child(8) {
          transition-delay: 0.45s;
        }
        .grid-animate.visible > *:nth-child(9) {
          transition-delay: 0.5s;
        }
        .grid-animate.visible > *:nth-child(10) {
          transition-delay: 0.55s;
        }
        .grid-animate.visible > *:nth-child(11) {
          transition-delay: 0.6s;
        }
        .grid-animate.visible > *:nth-child(12) {
          transition-delay: 0.65s;
        }
      `}</style>
      <Header data-id="element-46" />
      <main className="flex-grow" data-id="element-47">
        <HeroSection data-id="element-48" />
        <CoursesSection data-id="element-49" />
        <FeaturedCourseSection data-id="element-50" />
        <TestimonialsSection data-id="element-51" />
        <CtaSection data-id="element-52" />
      </main>
      <Footer data-id="element-53" />
    </div>;
};
const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  return <section className="relative py-24 md:py-32 bg-gradient-to-b from-charcoal to-charcoal/95 overflow-hidden" data-id="element-54">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-55">
        <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Background" className="w-full h-full object-cover opacity-20" data-id="element-56" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/70 to-charcoal/90" data-id="element-57"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.03] mix-blend-soft-light" data-id="element-58"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-59">
        <div className="max-w-4xl mx-auto text-center" data-id="element-60">
          <div className={`transition-all duration-700 delay-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`} data-id="element-61">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6" data-id="element-62">
              <BookOpenIcon className="h-4 w-4 text-aqua mr-2" data-id="element-63" />
              <span className="text-white/90 text-sm font-medium" data-id="element-64">
                125+ Courses Available
              </span>
            </div>
          </div>
          <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white transition-all duration-700 delay-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`} data-id="element-65">
            Explore Our <span className="gradient-text" data-id="element-66">Complete Course</span>{' '}
            Library
          </h1>
          <p className={`text-xl text-white/80 mb-10 transition-all duration-700 delay-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`} data-id="element-67">
            Discover a wide range of accredited courses designed to enhance your
            skills and ensure compliance across all industry sectors
          </p>
          <div className={`max-w-2xl mx-auto transition-all duration-700 delay-900 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`} data-id="element-68">
            <div className="relative" data-id="element-69">
              <input type="text" placeholder="Search for courses..." className="w-full py-4 px-6 pr-12 rounded-lg border-2 border-white/20 bg-white/10 backdrop-blur-sm text-white placeholder-white/60 focus:outline-none focus:border-aqua transition-all duration-300" data-id="element-70" />
              <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-aqua transition-colors p-2" data-id="element-71">
                <SearchIcon className="h-5 w-5" data-id="element-72" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CoursesSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeDuration, setActiveDuration] = useState('all');
  const [activeLevel, setActiveLevel] = useState('all');
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const categories = [{
    id: 'all',
    name: 'All Courses'
  }, {
    id: 'compliance',
    name: 'Compliance',
    icon: <ShieldIcon className="h-4 w-4" data-id="element-73" />
  }, {
    id: 'food-safety',
    name: 'Food Safety',
    icon: <BookOpenIcon className="h-4 w-4" data-id="element-74" />
  }, {
    id: 'leadership',
    name: 'Leadership',
    icon: <UsersIcon className="h-4 w-4" data-id="element-75" />
  }, {
    id: 'professional',
    name: 'Professional Skills',
    icon: <BriefcaseIcon className="h-4 w-4" data-id="element-76" />
  }];
  const durations = [{
    id: 'all',
    name: 'Any Duration'
  }, {
    id: 'short',
    name: 'Under 1 hour'
  }, {
    id: 'medium',
    name: '1-3 hours'
  }, {
    id: 'long',
    name: '3+ hours'
  }];
  const levels = [{
    id: 'all',
    name: 'All Levels'
  }, {
    id: 'beginner',
    name: 'Beginner'
  }, {
    id: 'intermediate',
    name: 'Intermediate'
  }, {
    id: 'advanced',
    name: 'Advanced'
  }];
  // Sample course data
  const courses = [{
    id: 1,
    title: 'HACCP Food Safety Management',
    category: 'food-safety',
    level: 'intermediate',
    duration: '2.5 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.9,
    reviews: 128,
    certified: true
  }, {
    id: 2,
    title: 'GDPR Data Protection Essentials',
    category: 'compliance',
    level: 'beginner',
    duration: '1.5 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.7,
    reviews: 94,
    certified: true
  }, {
    id: 3,
    title: 'Team Leadership Fundamentals',
    category: 'leadership',
    level: 'intermediate',
    duration: '4 hours',
    durationType: 'long',
    image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
    rating: 4.8,
    reviews: 156,
    certified: true
  }, {
    id: 4,
    title: 'Fire Safety in the Workplace',
    category: 'compliance',
    level: 'beginner',
    duration: '45 minutes',
    durationType: 'short',
    image: 'https://images.unsplash.com/photo-1599594749596-97195d63fbb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.6,
    reviews: 78,
    certified: true
  }, {
    id: 5,
    title: 'Effective Communication Skills',
    category: 'professional',
    level: 'intermediate',
    duration: '3 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.9,
    reviews: 112,
    certified: true
  }, {
    id: 6,
    title: 'Manual Handling Certification',
    category: 'compliance',
    level: 'beginner',
    duration: '1 hour',
    durationType: 'short',
    image: 'https://images.unsplash.com/photo-1540496905036-5937c10647cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.7,
    reviews: 86,
    certified: true
  }, {
    id: 7,
    title: 'Customer Service Excellence',
    category: 'professional',
    level: 'intermediate',
    duration: '2 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1556745753-b2904692b3cd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1266&q=80',
    rating: 4.8,
    reviews: 92,
    certified: true
  }, {
    id: 8,
    title: 'Advanced Management Strategies',
    category: 'leadership',
    level: 'advanced',
    duration: '5 hours',
    durationType: 'long',
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.9,
    reviews: 64,
    certified: true
  }, {
    id: 9,
    title: 'Food Allergen Awareness',
    category: 'food-safety',
    level: 'beginner',
    duration: '1.5 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1615485290382-441e4d049cb5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.8,
    reviews: 76,
    certified: true
  }, {
    id: 10,
    title: 'Health and Safety Essentials',
    category: 'compliance',
    level: 'beginner',
    duration: '2 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1581093804475-577d72e15032?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.7,
    reviews: 102,
    certified: true
  }, {
    id: 11,
    title: 'Digital Marketing Fundamentals',
    category: 'professional',
    level: 'intermediate',
    duration: '4 hours',
    durationType: 'long',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1115&q=80',
    rating: 4.8,
    reviews: 88,
    certified: true
  }, {
    id: 12,
    title: 'Conflict Resolution in the Workplace',
    category: 'leadership',
    level: 'advanced',
    duration: '3 hours',
    durationType: 'medium',
    image: 'https://images.unsplash.com/photo-1573497620299-d799571c7a80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    rating: 4.9,
    reviews: 74,
    certified: true
  }];
  // Filter courses based on active filters
  const filteredCourses = courses.filter(course => {
    const categoryMatch = activeCategory === 'all' || course.category === activeCategory;
    const durationMatch = activeDuration === 'all' || course.durationType === activeDuration;
    const levelMatch = activeLevel === 'all' || course.level === activeLevel;
    return categoryMatch && durationMatch && levelMatch;
  });
  return <section ref={sectionRef} className="py-20 bg-white" data-id="element-77">
      <div className="container mx-auto px-4 md:px-6" data-id="element-78">
        {/* Filters */}
        <div className="mb-12" data-id="element-79">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8" data-id="element-80">
            <h2 className="text-3xl font-bold text-charcoal mb-6 md:mb-0" data-id="element-81">
              Browse Our <span className="gradient-text" data-id="element-82">Course Catalog</span>
            </h2>
            <div className="flex items-center" data-id="element-83">
              <div className="relative" data-id="element-84">
                <select className="appearance-none bg-white border border-gray-200 rounded-lg py-2 px-4 pr-10 text-charcoal focus:outline-none focus:border-teal" data-id="element-85">
                  <option data-id="element-86">Most Popular</option>
                  <option data-id="element-87">Newest First</option>
                  <option data-id="element-88">Highest Rated</option>
                  <option data-id="element-89">Duration: Short to Long</option>
                  <option data-id="element-90">Duration: Long to Short</option>
                </select>
                <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-charcoal/60 h-4 w-4 pointer-events-none" data-id="element-91" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-92">
            <div data-id="element-93">
              <h3 className="text-sm uppercase text-charcoal/60 font-semibold mb-3" data-id="element-94">
                Categories
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-95">
                {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeCategory === category.id ? 'bg-teal text-white shadow-md' : 'bg-gray-100 text-charcoal/80 hover:bg-gray-200'}`} data-id="element-96">
                    {category.icon && <span className="mr-2" data-id="element-97">{category.icon}</span>}
                    {category.name}
                  </button>)}
              </div>
            </div>
            <div data-id="element-98">
              <h3 className="text-sm uppercase text-charcoal/60 font-semibold mb-3" data-id="element-99">
                Duration
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-100">
                {durations.map(duration => <button key={duration.id} onClick={() => setActiveDuration(duration.id)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeDuration === duration.id ? 'bg-teal text-white shadow-md' : 'bg-gray-100 text-charcoal/80 hover:bg-gray-200'}`} data-id="element-101">
                    {duration.name}
                  </button>)}
              </div>
            </div>
            <div data-id="element-102">
              <h3 className="text-sm uppercase text-charcoal/60 font-semibold mb-3" data-id="element-103">
                Level
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-104">
                {levels.map(level => <button key={level.id} onClick={() => setActiveLevel(level.id)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeLevel === level.id ? 'bg-teal text-white shadow-md' : 'bg-gray-100 text-charcoal/80 hover:bg-gray-200'}`} data-id="element-105">
                    {level.name}
                  </button>)}
              </div>
            </div>
          </div>
        </div>
        {/* Course Grid */}
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 grid-animate ${isVisible ? 'visible' : ''}`} data-id="element-106">
          {filteredCourses.map(course => <div key={course.id} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 card-hover" data-id="element-107">
              <div className="relative h-48" data-id="element-108">
                <img src={course.image} alt={course.title} className="w-full h-full object-cover" data-id="element-109" />
                <div className="absolute top-3 left-3" data-id="element-110">
                  {course.certified && <div className="bg-teal text-white text-xs font-medium px-2 py-1 rounded-md flex items-center" data-id="element-111">
                      <BadgeCheckIcon className="h-3 w-3 mr-1" data-id="element-112" />
                      Certified
                    </div>}
                </div>
              </div>
              <div className="p-6" data-id="element-113">
                <div className="flex items-center mb-2" data-id="element-114">
                  <span className="text-xs font-medium px-2.5 py-0.5 bg-gray-100 text-charcoal/70 rounded-full" data-id="element-115">
                    {categories.find(c => c.id === course.category)?.name}
                  </span>
                  <span className="ml-2 text-xs font-medium px-2.5 py-0.5 bg-gray-100 text-charcoal/70 rounded-full flex items-center" data-id="element-116">
                    <ClockIcon className="h-3 w-3 mr-1" data-id="element-117" />
                    {course.duration}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-118">
                  {course.title}
                </h3>
                <div className="flex items-center mb-4" data-id="element-119">
                  <div className="flex items-center" data-id="element-120">
                    <StarIcon className="h-4 w-4 text-amber-400" data-id="element-121" />
                    <span className="ml-1 text-charcoal font-medium" data-id="element-122">
                      {course.rating}
                    </span>
                  </div>
                  <span className="text-charcoal/60 text-sm ml-2" data-id="element-123">
                    ({course.reviews} reviews)
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-124">
                  <span className="text-sm font-medium text-charcoal/70" data-id="element-125">
                    Level: {levels.find(l => l.id === course.level)?.name}
                  </span>
                  <a href={`/course/${course.id}`} className="inline-flex items-center text-teal font-medium hover:text-aqua transition-colors" data-id="element-126">
                    View Course
                    <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-127" />
                  </a>
                </div>
              </div>
            </div>)}
        </div>
        {/* Pagination */}
        <div className="mt-12 flex justify-center" data-id="element-128">
          <div className="flex items-center space-x-2" data-id="element-129">
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 text-charcoal/70 hover:bg-gray-50 transition-colors" data-id="element-130">
              <ArrowLeftIcon className="h-4 w-4" data-id="element-131" />
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-teal text-white" data-id="element-132">
              1
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 text-charcoal hover:bg-gray-50 transition-colors" data-id="element-133">
              2
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 text-charcoal hover:bg-gray-50 transition-colors" data-id="element-134">
              3
            </a>
            <span className="text-charcoal/60" data-id="element-135">...</span>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 text-charcoal hover:bg-gray-50 transition-colors" data-id="element-136">
              8
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 text-charcoal/70 hover:bg-gray-50 transition-colors" data-id="element-137">
              <ArrowRightIcon className="h-4 w-4" data-id="element-138" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};
const FeaturedCourseSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-24 bg-gray-50" data-id="element-139">
      <div className="container mx-auto px-4 md:px-6" data-id="element-140">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-141">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-6" data-id="element-142">
            <GraduationCapIcon className="h-6 w-6 text-teal" data-id="element-143" />
          </div>
          <h2 className="text-4xl font-bold mb-6 text-charcoal" data-id="element-144">
            Featured <span className="gradient-text" data-id="element-145">Learning Paths</span>
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-146">
            Structured course sequences designed to build comprehensive
            expertise in key areas
          </p>
        </div>
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto transition-all duration-700 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-147">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100" data-id="element-148">
            <div className="relative h-52" data-id="element-149">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Complete Food Safety Pathway" className="w-full h-full object-cover" data-id="element-150" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 to-transparent" data-id="element-151"></div>
              <div className="absolute bottom-4 left-6" data-id="element-152">
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-153">
                  Complete Food Safety Pathway
                </h3>
                <p className="text-white/80" data-id="element-154">4 Courses • 10 Hours Total</p>
              </div>
            </div>
            <div className="p-6" data-id="element-155">
              <p className="text-charcoal/80 mb-6" data-id="element-156">
                Comprehensive training covering all aspects of food safety
                management, from basic hygiene to advanced HACCP implementation.
              </p>
              <div className="space-y-3 mb-6" data-id="element-157">
                <div className="flex items-start" data-id="element-158">
                  <CheckCircleIcon className="h-5 w-5 text-teal mr-3 mt-0.5 flex-shrink-0" data-id="element-159" />
                  <div data-id="element-160">
                    <p className="font-medium text-charcoal" data-id="element-161">
                      Food Safety Level 1-3
                    </p>
                    <p className="text-charcoal/60 text-sm" data-id="element-162">
                      Essential certification for all food handlers
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-163">
                  <CheckCircleIcon className="h-5 w-5 text-teal mr-3 mt-0.5 flex-shrink-0" data-id="element-164" />
                  <div data-id="element-165">
                    <p className="font-medium text-charcoal" data-id="element-166">
                      HACCP Principles
                    </p>
                    <p className="text-charcoal/60 text-sm" data-id="element-167">
                      Risk assessment and critical control points
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-168">
                  <CheckCircleIcon className="h-5 w-5 text-teal mr-3 mt-0.5 flex-shrink-0" data-id="element-169" />
                  <div data-id="element-170">
                    <p className="font-medium text-charcoal" data-id="element-171">
                      Allergen Management
                    </p>
                    <p className="text-charcoal/60 text-sm" data-id="element-172">
                      Compliant with EU food labeling regulations
                    </p>
                  </div>
                </div>
              </div>
              <a href="/learning-paths/food-safety" className="block w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300 text-center" data-id="element-173">
                Explore This Path
              </a>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100" data-id="element-174">
            <div className="relative h-52" data-id="element-175">
              <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Leadership Development Track" className="w-full h-full object-cover" data-id="element-176" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 to-transparent" data-id="element-177"></div>
              <div className="absolute bottom-4 left-6" data-id="element-178">
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-179">
                  Leadership Development Track
                </h3>
                <p className="text-white/80" data-id="element-180">5 Courses • 15 Hours Total</p>
              </div>
            </div>
            <div className="p-6" data-id="element-181">
              <p className="text-charcoal/80 mb-6" data-id="element-182">
                Transform your management potential with our comprehensive
                leadership program, from team dynamics to strategic
                decision-making.
              </p>
              <div className="space-y-3 mb-6" data-id="element-183">
                <div className="flex items-start" data-id="element-184">
                  <CheckCircleIcon className="h-5 w-5 text-teal mr-3 mt-0.5 flex-shrink-0" data-id="element-185" />
                  <div data-id="element-186">
                    <p className="font-medium text-charcoal" data-id="element-187">
                      Team Leadership Fundamentals
                    </p>
                    <p className="text-charcoal/60 text-sm" data-id="element-188">
                      Build essential management skills
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-189">
                  <CheckCircleIcon className="h-5 w-5 text-teal mr-3 mt-0.5 flex-shrink-0" data-id="element-190" />
                  <div data-id="element-191">
                    <p className="font-medium text-charcoal" data-id="element-192">
                      Effective Communication
                    </p>
                    <p className="text-charcoal/60 text-sm" data-id="element-193">
                      Enhance team collaboration and feedback
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-194">
                  <CheckCircleIcon className="h-5 w-5 text-teal mr-3 mt-0.5 flex-shrink-0" data-id="element-195" />
                  <div data-id="element-196">
                    <p className="font-medium text-charcoal" data-id="element-197">
                      Strategic Management
                    </p>
                    <p className="text-charcoal/60 text-sm" data-id="element-198">
                      Advanced decision-making frameworks
                    </p>
                  </div>
                </div>
              </div>
              <a href="/learning-paths/leadership" className="block w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300 text-center" data-id="element-199">
                Explore This Path
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-200">
          <a href="/learning-paths" className="inline-flex items-center px-8 py-4 bg-white text-charcoal font-medium rounded-lg border border-gray-200 hover:bg-gray-50 transition-all duration-300 shadow-md" data-id="element-201">
            View All Learning Paths
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-202" />
          </a>
        </div>
      </div>
    </section>;
};
const TestimonialsSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-24 bg-white" data-id="element-203">
      <div className="container mx-auto px-4 md:px-6" data-id="element-204">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-205">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-6" data-id="element-206">
            <StarIcon className="h-6 w-6 text-teal" data-id="element-207" />
          </div>
          <h2 className="text-4xl font-bold mb-6 text-charcoal" data-id="element-208">
            What Our <span className="gradient-text" data-id="element-209">Learners Say</span>
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-210">
            Join thousands of professionals who have transformed their skills
            with our courses
          </p>
        </div>
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto grid-animate ${isVisible ? 'visible' : ''}`} data-id="element-211">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 card-hover" data-id="element-212">
            <div className="p-8" data-id="element-213">
              <div className="flex mb-6" data-id="element-214">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400" data-id="element-215" />)}
              </div>
              <blockquote className="text-charcoal/80 italic mb-6 text-lg" data-id="element-216">
                "The HACCP course was incredibly comprehensive and practical. I
                was able to implement what I learned immediately in our
                restaurant."
              </blockquote>
              <div className="flex items-center" data-id="element-217">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80" alt="Sarah Johnson" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-218" />
                <div data-id="element-219">
                  <p className="font-bold text-charcoal" data-id="element-220">Sarah Johnson</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-221">Restaurant Manager</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 card-hover" data-id="element-222">
            <div className="p-8" data-id="element-223">
              <div className="flex mb-6" data-id="element-224">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400" data-id="element-225" />)}
              </div>
              <blockquote className="text-charcoal/80 italic mb-6 text-lg" data-id="element-226">
                "The leadership program transformed how I manage my team. The
                practical strategies were easy to implement right away."
              </blockquote>
              <div className="flex items-center" data-id="element-227">
                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Michael Chen" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-228" />
                <div data-id="element-229">
                  <p className="font-bold text-charcoal" data-id="element-230">Michael Chen</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-231">
                    Operations Director
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 card-hover" data-id="element-232">
            <div className="p-8" data-id="element-233">
              <div className="flex mb-6" data-id="element-234">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400" data-id="element-235" />)}
              </div>
              <blockquote className="text-charcoal/80 italic mb-6 text-lg" data-id="element-236">
                "The GDPR course was exactly what our team needed. Clear,
                concise, and perfectly aligned with EU regulations."
              </blockquote>
              <div className="flex items-center" data-id="element-237">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=761&q=80" alt="Emma Richards" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-238" />
                <div data-id="element-239">
                  <p className="font-bold text-charcoal" data-id="element-240">Emma Richards</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-241">CEO, TechStart</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CtaSection = () => {
  return <section className="py-20 bg-gradient-to-br from-teal to-teal/90 relative overflow-hidden" data-id="element-242">
      <div className="absolute inset-0 overflow-hidden" data-id="element-243">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-white/10 blur-3xl" data-id="element-244"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 rounded-full bg-white/5 blur-3xl" data-id="element-245"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.03] mix-blend-soft-light" data-id="element-246"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-247">
        <div className="max-w-4xl mx-auto text-center" data-id="element-248">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 mb-6" data-id="element-249">
            <LightbulbIcon className="h-8 w-8 text-white" data-id="element-250" />
          </div>
          <h2 className="text-4xl font-bold mb-6 text-white tracking-tight" data-id="element-251">
            Not Sure Where to Start? <br data-id="element-252" />
            <span className="text-white" data-id="element-253">Get Personalized Recommendations</span>
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-3xl mx-auto" data-id="element-254">
            Answer a few questions about your goals and industry, and we'll
            suggest the perfect courses for your needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-5 justify-center" data-id="element-255">
            <a href="/course-finder" className="inline-flex items-center justify-center px-8 py-4 font-medium text-teal bg-white rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg" data-id="element-256">
              Find My Ideal Course
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-257" />
            </a>
            <a href="/contact" className="inline-flex items-center justify-center px-8 py-4 font-medium text-white bg-transparent border-2 border-white/30 rounded-lg hover:bg-white/10 transition-all duration-300" data-id="element-258">
              Talk to an Advisor
            </a>
          </div>
        </div>
      </div>
    </section>;
};